import React from "react";
import ForecastIcon from "./ForecastIcon";

export default function DailyForecast(props) {
  let Temp = Math.round(props.data.temperature.day);
  let maxTemperature = Math.round(props.data.temperature.maximum);
  let minTemperature = Math.round(props.data.temperature.minimum);
  function weekday() {
    let date = new Date(props.data.time * 1000);
    let day = date.getDay();

    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return days[day];
  }
  return (
    <div>
      <h3>{weekday()}</h3>
      <p>
        Average:{Temp}°C, Max: {maxTemperature}°C Min: {minTemperature}°C
      </p>
      <p>Conditions: {props.data.condition.description}</p>
      <ForecastIcon code={props.data.condition.icon} />
    </div>
  );
}
